/* 文件管理 */
export default {
  // 创建项目
  createProject: {
    url: "/fileManageApi/createProject",
    method: "post"
  },
  // 获取项目列表
  getProjects: {
    url: "/fileManageApi/getProjects",
    method: "post"
  },
  // 获取项目详情
  getProjectDetail: {
    url: "/fileManageApi/getProjectDetail",
    method: "get"
  },
  // 获取项目编辑权限
  getProjectEditPower: {
    url: "/fileManageApi/getProjectEditPower",
    method: "get"
  },
  // 编辑项目信息
  editProject: {
    url: "/fileManageApi/editProject",
    method: "post"
  },
  // 项目开放或关闭接口
  changeProjectOpenStatus: {
    url: "/fileManageApi/changeProjectOpenStatus",
    method: "post"
  },
  // 添加项目成员
  addProjectMember: {
    url: "/fileManageApi/addProjectMember",
    method: "post"
  },
  // 删除项目成员
  removeProjectMember: {
    url: "/fileManageApi/removeProjectMember",
    method: "get"
  },
  // 修改成员角色
  changeMemberRole: {
    url: "/fileManageApi/changeMemberRole",
    method: "post"
  },
  // 获取项目成员
  getProjectMembers: {
    url: "/fileManageApi/getProjectMembers",
    method: "get"
  },
  // 获取环境列表
  getEnvList: {
    url: "/fileManageApi/getEnvList",
    method: "get"
  },
  // 获取当前目录文件
  getDirectoryFiles: {
    url: "/fileManageApi/getDirectoryFiles",
    method: "post"
  },
  // 新增目录
  addDirectory: {
    url: "/fileManageApi/addDirectory",
    method: "post"
  },
  // 获取文件详情
  getFileDetail: {
    url: "/fileManageApi/getFileDetail",
    method: "post"
  },
  // 查询文件
  findSystemFile: {
    url: "/fileManageApi/findSystemFile",
    method: "post"
  },
  // 查询指定日期文件
  findDateFile: {
    url: "/fileManageApi/findDateFile",
    method: "post"
  },
  // 查询日历日期文件数量
  findCalendarFileCount: {
    url: "/fileManageApi/findCalendarFileCount",
    method: "post"
  },
  // 查询日历日期文件数量
  deleteFile: {
    url: "/fileManageApi/deleteFile",
    method: "post"
  },
}
